import script from "./LinkToEnvironment.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkToEnvironment.vue?vue&type=script&setup=true&lang=js"

import "./LinkToEnvironment.vue?vue&type=style&index=0&id=fc921a06&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc921a06"]])

export default __exports__